// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
@media (max-width: 37.4rem) {
  .style_hide-sm__toUb1 {
    display: none !important;
  }
}
@media (min-width: 37.4rem) {
  .style_visible-sm__El_EY {
    display: none !important;
  }
}
@media (max-width: 79.9rem) {
  .style_hide-md__R_dzs {
    display: none !important;
  }
}
@media (min-width: 79.9rem) {
  .style_visible-md__DFOOq {
    display: none !important;
  }
}
.style_heading__Q7lOV {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0;
}
.style_headingText__LGyFm {
  flex-grow: 1;
}
.style_resetButton__GgY4K {
  margin: 0 !important;
}
.style_fullHeightContainer__ARBIM {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1 1 auto;
}
.style_headingSection__FFTQc {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
.style_filterHeaderContainer__JU1Q6 {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;
}
@media (max-width: 37.4rem) {
  .style_filterHeaderContainer__JU1Q6 {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_filterHeaderContainer__JU1Q6 > :not(:first-child) {
  margin-left: 1rem;
}
.style_filterHeaderContainer__JU1Q6 > :last-child {
  margin-left: 0.5rem;
}
.style_additionalHeaderFilter__ww_4G {
  align-self: flex-start;
  max-height: 3rem;
}
.style_filteringByItems__cQQZB {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.style_filteringBy__K4wyv {
  width: 100%;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
}
.style_matchInfo__wlXx3 {
  margin-left: 0.75rem;
}
.style_info__wbH9A {
  color: var(--colorTextInfo);
}
`, "",{"version":3,"sources":["webpack://./app/components/AdvancedFilterLayout/style.less","webpack://./app/resources/styles/media.less"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;ACNF;EACE;IACE,wBAAA;EDQF;AACF;ACLA;EACE;IACE,wBAAA;EDOF;AACF;ACJA;EACE;IACE,wBAAA;EDMF;AACF;ACJA;EACE;IACE,wBAAA;EDMF;AACF;AA7BA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AA+BJ;AA5BA;EACI,YAAA;AA8BJ;AA3BA;EACI,oBAAA;AA6BJ;AA1BA;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;AA4BJ;AAzBA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AA2BJ;AAxBA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,YAAA;AAyBJ;AAvBI;EAAA;IACI,sBAAA;IACA,uBAAA;EA0BN;AACF;AAvBA;EACI,iBAAA;AAyBJ;AAtBA;EACI,mBAAA;AAwBJ;AArBA;EACI,sBAAA;EACA,gBAAA;AAuBJ;AApBA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAsBJ;AAnBA;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAqBJ;AAlBA;EACI,oBAAA;AAoBJ;AAjBA;EACI,2BAAA;AAmBJ","sourcesContent":["@import \"../../resources/styles/colors\";\n@import \"../../resources/styles/media\";\n\n.heading {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-top: 0;\n}\n\n.headingText {\n    flex-grow: 1;\n}\n\n.resetButton {\n    margin: 0 !important;\n}\n\n.fullHeightContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex: 1 1 auto;\n}\n\n.headingSection {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap; // Need this to wrap for mobile.\n}\n\n.filterHeaderContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: center; //baseline; // mark.siedle - baseline screws up when you use our select lists for some reason :/\n    //justify-content: flex-start;\n    flex-grow: 1;\n\n    @media (max-width: @screen-sm) {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n.filterHeaderContainer > :not(:first-child){\n    margin-left: 1rem;\n}\n\n.filterHeaderContainer > :last-child {\n    margin-left: 0.5rem;\n}\n\n.additionalHeaderFilter {\n    align-self: flex-start;\n    max-height: 3rem;\n}\n\n.filteringByItems {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.filteringBy {\n    width: 100%;\n    flex-wrap: wrap;\n    display: flex;\n    align-items: center;\n}\n\n.matchInfo {\n    margin-left: 0.75rem;\n}\n\n.info {\n    color: @info;\n}","//@screen-xs: 480px;\n@screen-sm: 37.4rem; //600px\n@screen-md: 79.9rem; //1279px\n//@screen-lg-min: 1280px;\n//@scree-xl-min: 1920px;\n\n@media (max-width: @screen-sm) {\n  .hide-sm {\n    display: none !important;\n  }\n}\n\n@media (min-width: @screen-sm) {\n  .visible-sm {\n    display: none !important;\n  }\n}\n\n@media (max-width: @screen-md) {\n  .hide-md {\n    display: none !important;\n  }\n}\n@media (min-width: @screen-md) {\n  .visible-md {\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hide-sm": `style_hide-sm__toUb1`,
	"hideSm": `style_hide-sm__toUb1`,
	"visible-sm": `style_visible-sm__El_EY`,
	"visibleSm": `style_visible-sm__El_EY`,
	"hide-md": `style_hide-md__R_dzs`,
	"hideMd": `style_hide-md__R_dzs`,
	"visible-md": `style_visible-md__DFOOq`,
	"visibleMd": `style_visible-md__DFOOq`,
	"heading": `style_heading__Q7lOV`,
	"headingText": `style_headingText__LGyFm`,
	"resetButton": `style_resetButton__GgY4K`,
	"fullHeightContainer": `style_fullHeightContainer__ARBIM`,
	"headingSection": `style_headingSection__FFTQc`,
	"filterHeaderContainer": `style_filterHeaderContainer__JU1Q6`,
	"additionalHeaderFilter": `style_additionalHeaderFilter__ww_4G`,
	"filteringByItems": `style_filteringByItems__cQQZB`,
	"filteringBy": `style_filteringBy__K4wyv`,
	"matchInfo": `style_matchInfo__wlXx3`,
	"info": `style_info__wbH9A`
};
module.exports = ___CSS_LOADER_EXPORT___;
